// Course options from the PDF
export const COURSE_OPTIONS = [
  "SIT30821 Certificate III in Commercial Cookery",
  "SIT40521 Certificate IV in Kitchen Management",
  "SIT50422 Diploma of Hospitality Management",
  "SIT60322 Advanced Diploma of Hospitality Management",
  "BSB50420 Diploma of Leadership and Management",
  "BSB60420 Advanced Diploma of Leadership and Management",
  "BSB80120 Graduate Diploma of Management (Learning)",
  "ICT50220 Diploma of Information Technology (Cybersecurity)",
  "ICT60220 Advanced Diploma of Information Technology (Cybersecurity and Telecommunications)",
  "CPC30326 Certificate III in Carpentry",
  "CPC33020 Certificate III in Bricklaying and Block Laying",
  "CPC30620 Certificate III in Painting and Decorating",
  "CPC40120 Certificate IV in Building and Construction (Building)",
  "CPC50220 Diploma of Building and Construction (Building)",
  "CPC60220 Advanced Diploma of Building and Construction Management",
  "CHC33021 Certificate III in Individual Support",
  "CHC43121 Certificate IV in Disability Support",
  "CHC52025 Diploma of Community Services",
];
export const COURSE_OPTIONS_DOMESTIC = [
  "SIT30821 Certificate III in Commercial Cookery",
  "SIT40521 Certificate IV in Kitchen Management",
  "SIT50422 Diploma of Hospitality Management",
  "SIT60322 Advanced Diploma of Hospitality Management",
  "BSB50420 Diploma of Leadership and Management",
  "BSB60420 Advanced Diploma of Leadership and Management",
  "BSB80120 Graduate Diploma of Management (Learning)",
  "ICT50220 Diploma of Information Technology (Cybersecurity)",
  "ICT60220 Advanced Diploma of Information Technology (Cybersecurity and Telecommunications)",
  "CPC30326 Certificate III in Carpentry",
  "CPC33020 Certificate III in Bricklaying and Block Laying",
  "CPC30620 Certificate III in Painting and Decorating",
  "CPC40120 Certificate IV in Building and Construction (Building)",
  "CPC50220 Diploma of Building and Construction (Building)",
  "CPC60220 Advanced Diploma of Building and Construction Management",
  "CHC33021 Certificate III in Individual Support",
  "CHC43121 Certificate IV in Disability Support",
  "CHC52025 Diploma of Community Services",
  "CPCCWHS1001 White Card",
  "10830NAT Silica Awareness",
  "11084NAT Asbestos Awareness",
  "HLTAID003 Provide First Aid",
];
export const MONTHS = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

export const DISABILITY_AREAS = [
  "Hearing/deaf",
  "Physical",
  "Intellectual",
  "Learning",
  "Mental illness",
  "Acquired brain impairment",
  "Vision",
  "Medical condition",
  "Other"
];

export const COMPLETED_LEVELS = [
  "Bachelor's degree or higher degree",
  "Advanced diploma or associate degree",
  "Diploma (or associate diploma)",
  "Certificate IV (or advanced certificate/technician)",
  "Certificate III (or trade certificate)",
  "Certificate II",
  "Certificate I",
  "Other education (including certificates or overseas qualifications not listed here)",
];

export const EMPLOYMENT_STATUSES = [
  "Full-time employee",
  "Part-time employee",
  "Self-employed – not employing others",
  "Self-employed – employing others",
  "Employed – unpaid worker in a family business",
  "Unemployed – seeking full-time work",
  "Unemployed – seeking part-time work",
  "Not employed – not seeking employment",
  "Not Applicable"
];

export const STUDY_REASONS = [
  "To get a job",
  "To develop my existing business",
  "To start my own business",
  "To try for a different career",
  "To get a better job or promotion",
  "It was a requirement of my job",
  "I wanted extra skills for my job",
  "To get into another course of study",
  "For personal interest or self-development",
  "To get skills for community/voluntary work",
  "Other reasons"
];

export const SECTION_KEYS = [
  "personal",
  "campusCourse",
  "intake",
  "visa",
  "languageCulture",
  "disability",
  "schoolingQualifications",
  "oshc",
  "employmentStudyReason",
  "additionalServices",
  "rplCredit",
  "usi",
  "declaration"
];
export const DOMESTIC_SECTION_KEYS = [
  "personal",
  "campusCourse",
  "intake",
  "visa",
  "disability",
  "schoolingQualifications",
  "employmentStudyReason",
  "additionalServices",
  "rplCredit",
  "usi",
  "declaration"
];
export const STUDENT_SECTION_KEYS = [
  "enrolmentForm",
  "studentRecord",
  "feesPlan",
  // "actions"
];
// Add this mapping at the top of ViewEnrolmentForm.jsx
export const SECTION_LABELS = {
  personal: "1. Personal",
  campusCourse: "2. Campus Course",
  intake: "3. Intake",
  visa: "4. Visa",
  languageCulture: "5. Language & Culture",
  disability: "6. Disability",
  schoolingQualifications: "7. Schooling & Qualifications",
  oshc: "8. OSHC",
  employmentStudyReason: "9. Employment / Study",
  additionalServices: "10. Additional Services",
  rplCredit: "11. RPL / Credit",
  usi: "12. USI",
  declaration: "13. Declaration",
  actions: "Actions"
};
// Add this mapping at the top of ViewEnrolmentForm.jsx
export const SECTION_LABELS_DOMESTIC = {
  personal: "1. Personal",
  campusCourse: "2. Campus Course",
  intake: "3. Intake",
  visa: "4. Visa",
  disability: "5. Disability",
  schoolingQualifications: "6. Schooling & Qualifications",
  employmentStudyReason: "7. Employment / Study",
  additionalServices: "8. Additional Services",
  rplCredit: "9. RPL / Credit",
  usi: "10. USI",
  declaration: "11. Declaration",
  actions: "Actions"
};
// Add student
export const STUDENT_SECTION_LABELS = {
  studentRecord: "Student Record",
  enrolmentForm: "Enrollment Form",
  feesPlan: "Fees Tracker",
  // commissions: "Agent Commission",
  followUps: "Follow Ups",
  agentCommissions: "Agent Commission",
  actions: "Actions"
};
export const AGENT_SECTION_KEYS = [
  "agentApplication",
  "agentRecord",
  "agentAnalytics",
  "students",
  "commissions"
];
export const AGENT_SECTION_LABELS = {
  agentApplication: "New Agent Application",
  agentRecord: "Agent Record",
  agentAnalytics: "Agent Analytics",
  students: "Linked Students",
  commissions: "Commissions"
};
export const CIET_URL = "https://ciet.app.axcelerate.com";